<div class="container">
  <div class="text-center mt-4">
    <img id="logo" class="img-fluid" src="images/akvarium_logo.svg">
  </div>
  <div class="text-center w-fit-content mw-80 mx-auto my-5">
    <p class="lead text-primary fw-bold" translate>LANDING.LEAD</p>
    <div class="mt-4">
      <div *ngFor="let ticket of tickets$ | async">
        <button type="button" class="btn btn-lg w-100" (click)="selectTicketById(ticket.id)" [disabled]="!ticket.available"
          [class]="{'btn-primary': selectedTicketId === ticket.id, 'btn-outline-primary': selectedTicketId !== ticket.id && ticket.available, 'btn-dark': !ticket.available}">
          <span class="fw-bold">{{ticket.label[locale]}}</span><br>
          <span class="fs-6">{{ticket.description[locale]}}</span>
        </button>
        <p>
          <span>{{ticket.priceHUF}} </span>
          <span translate>LANDING.CURRENCY_AND_VAT</span>
          <span> | {{ticket.available}} </span>
          <span translate>LANDING.AVAILABLE</span>
        </p>
      </div>
    </div>
    <div class="form-check form-switch w-fit-content mx-auto mt-5 mb-3">
      <input class="form-check-input" type="checkbox" role="switch" id="accept-ToS" [(ngModel)]="acceptedToS">
      <label class="form-check-label" for="accept-ToS" translate>LANDING.ACCEPT_TOS</label>
    </div>
    <button type="button" class="btn btn-dark btn-lg w-100" (click)="continuePayment()"
      [disabled]="selectedTicketId === '' || inProgress || !acceptedToS">
      <span *ngIf="!inProgress" translate>LANDING.BTN_CONTINUE</span>
      <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
    </button>
  </div>
</div>
